{
    "title": "إعدادات الذكاء الاصطناعي",
    "description": "أي نموذج يتولى أي قدرة، وكم يكلّف، وما الذي يُسمح له بالاطلاع عليه.",
    "provenance": {
        "model": "اقترحه {{model}}",
        "deterministic": "اقتراح مبني على الكلمات المفتاحية",
        "template": "إشعار استلام قياسي",
        "confidence": "نسبة الثقة {{percent}}٪"
    },
    "analysis": {
        "not_analysed": "لم يُحلَّل بعد.",
        "risk": "المخاطر {{score}}",
        "overridden": "صحّحه موظف",
        "rerun": "إعادة التحليل",
        "refreshed": "تم تحديث التحليل."
    },
    "suggestions": {
        "title": "حلول مقترحة",
        "empty": "لا يوجد في قاعدة المعرفة ما يطابق هذه الشكوى بعد.",
        "relevance": "تطابق {{percent}}٪"
    },
    "draft": {
        "title": "مسودة الرد",
        "generate": "صياغة رد",
        "empty": "اطلب مسودة لتبدأ منها. وستتمكن من تعديلها قبل الإرسال.",
        "use": "استخدام المسودة",
        "not_useful": "غير مفيدة",
        "review_note": "لا يُرسل شيء تلقائياً. تنتقل المسودة إلى محرر الرد لتعدّلها وترسلها بنفسك."
    },
    "feedback": {
        "thanks": "شكراً لك — تم تسجيل ملاحظتك."
    },
    "providers": {
        "title": "المزوّدون",
        "add": "إضافة مزوّد",
        "none": "لا يوجد مزوّد مهيأ. كل شيء يعمل على الطبقة المدمجة الحتمية.",
        "built_in": "مدمج",
        "test": "اختبار الاتصال",
        "testing": "جارٍ الاختبار…",
        "credential": "مفتاح الواجهة البرمجية",
        "credential_help": "يُخزَّن مشفّراً ولا يُعاد أبداً. اتركه فارغاً للإبقاء على المفتاح الحالي.",
        "credential_set": "المفتاح مهيأ: {{fingerprint}}",
        "offshore": "يرسل البيانات خارج البنك",
        "local": "يبقى داخل البنك",
        "health": {
            "ok": "سليم",
            "degraded": "متعثر",
            "down": "غير متاح",
            "unknown": "لم يُختبر"
        }
    },
    "routing": {
        "title": "توجيه القدرات",
        "description": "يمكن لكل قدرة استخدام نموذج مختلف، أو لا نموذج إطلاقاً. وما لا يُوجَّه يستخدم الطبقة المدمجة الحتمية.",
        "deterministic": "المدمج (حتمي)",
        "sends_text": "يرسل كلام العميل نفسه",
        "no_text": "لا يرسل نص العميل",
        "egress_warning": "المشاركة الخارجية معطّلة، لذا ستستخدم القدرات التي ترسل نص العميل الطبقة المدمجة أياً كان النموذج المحدد هنا.",
        "allow_fallback": "الرجوع للمدمج عند الإخفاق",
        "enabled": "مفعّلة",
        "live": "نموذج فعلي",
        "fallback_active": "مدمج"
    },
    "playground": {
        "title": "جرّبه",
        "description": "شغّل القدرة على نص تختاره أنت قبل أن تبدأ بمعالجة شكاوى حقيقية.",
        "text": "النص",
        "text_placeholder": "الصق شكوى بالعربية أو الإنجليزية…",
        "run": "تشغيل",
        "result": "النتيجة"
    },
    "usage": {
        "title": "استخدام الذكاء الاصطناعي وتكلفته",
        "description": "ما قامت به الطبقة، وكم كلّف، وكم منه لم يحتج نموذجاً أصلاً.",
        "total_requests": "الطلبات",
        "deterministic": "أُنجز بلا نموذج",
        "cost": "الإنفاق",
        "budget": "الميزانية",
        "failed": "الإخفاقات",
        "cached": "من التخزين المؤقت",
        "by_capability": "حسب القدرة",
        "by_provider": "حسب المزوّد",
        "accuracy": "الفائدة المقاسة",
        "accuracy_note": "مأخوذة من قرارات الموظفين بالقبول والتعديل والرفض، لا من ثقة النموذج بنفسه. ويُحتسب الاقتراح المعدَّل نصف صحيح.",
        "no_spend_note": "لم يُنفق شيء. فكل إجابة حتى الآن جاءت من الطبقة المدمجة الحتمية.",
        "export": "تصدير الملاحظات (JSONL)"
    },
    "knowledge": {
        "title": "قاعدة المعرفة",
        "description": "ما يجوز للطبقة أن تستقي منه إجاباتها. ويراعي الاسترجاع الأدوار، فلا يُقتبس مستند مقيَّد لمن لا يحق له فتحه.",
        "add": "إضافة مستند",
        "empty": "لا توجد مستندات بعد.",
        "chunks": "مقطع واحد",
        "chunks_plural": "{{count}} مقاطع",
        "reindex": "إعادة الفهرسة",
        "search": "اختبار الاسترجاع",
        "search_placeholder": "اسأل ما قد يسأله الموظف…",
        "status": {
            "pending": "قيد الفهرسة",
            "indexed": "مفهرس",
            "failed": "أخفق"
        },
        "restricted": "مقيَّد",
        "visible_to_all": "الجميع"
    }
}
